import { CommonModule } from '@angular/common';
import {
    Component,
    EventEmitter,
    Input,
    Output,
    SkipSelf,
} from '@angular/core';
import {
    ControlContainer,
    FormsModule,
    ReactiveFormsModule,
} from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'textarea-general-variant',
    templateUrl: './textarea-general-variant.component.html',
    styleUrls: ['./textarea-general-variant.component.scss'],
    standalone: true,
    imports: [MatIconModule, CommonModule, FormsModule, ReactiveFormsModule],
    viewProviders: [
        {
            provide: ControlContainer,
            useFactory: (container: ControlContainer) => container,
            deps: [[new SkipSelf(), ControlContainer]],
        },
    ],
})
export class TextAreaGeneralVariantComponent {
    @Input() label: string | null = null;
    @Input() currentValue: string = '';
    @Input() placeHolder: string = '';
    @Output() selectionChange: EventEmitter<any> = new EventEmitter<any>();
    @Input() mandatoryField: boolean = false;
    @Input() inputType: string = 'text';
    @Input() hideInput: boolean = false;
    @Input() class: string = '';
    @Input() removeValue: boolean = false;
    @Input() errors: string[] = [];
    @Input() strength: null | number = null;
    @Input() strengthLabel: null | string = null;
    @Input() strengthColor: string = '#4b6eec';
    @Input() classOverrides: string | null = null;
    @Input() controlName?: string;
    @Input() maxlength: any;
    @Input() phoneNoCodeLabel?: string = undefined;
    @Output() phoneNoFieldChange: EventEmitter<any> = new EventEmitter<any>();

    strengthArray = [0, 1, 2, 3];

    hide: boolean;

    constructor() {
        this.hide = this.hideInput; // Set the initial value of hide based on hideInput
    }

    toggleHideInput() {
        this.hide = !this.hide;
    }
}
